import type { ItemAncestor } from '@/common/api/types/items';

/**
 * Sorts ancestors by depth in descending order for breadcrumb display.
 *
 * Note: Counterintuitively, higher depth numbers mean higher in hierarchy.
 * For example, Epic (depth: 2) is parent of Story (depth: 1).
 * This function sorts in descending order to get root-to-deepest order for breadcrumbs.
 *
 * @param ancestors - Array of item ancestors to sort
 * @returns New sorted array in root-to-deepest order
 */
export const sortAncestorsByDepth = (ancestors: ItemAncestor[]): ItemAncestor[] => {
  return [...ancestors].sort((a, b) => b.depth - a.depth);
};
